export default "/images/8d9938e9f6e988a53250e19f7403bb1d.avif";